module.exports = __webpack_public_path__ + "img/icon_vip_free_status.e7cd37dd.png";